(function () {
  'use strict';

  function flavor(product, variant) {
    if (variant.title !== 'Default Title') {
      return variant.title.replace(/ – 1 1\/4| - 1 1\/4| - King Size/g, '').trim();
    }
    const title = product.title.replace(/\([^)]*\)/g, '').trim();
    return title.split(/ [–-] /).map((part) => part.trim()).filter((part) => part && !/\d/.test(part)).pop() || title;
  }

  function words(value) {
    return value.toLowerCase().replace(/[-,.]/g, ' ').split(/\s+/).filter(Boolean);
  }

  function match(product, viewedFlavor, mode) {
    const available = product.variants.filter((variant) => variant.available);
    const viewed = words(viewedFlavor);
    const ignored = ['natural', 'variety', 'default'];
    return available.find((variant) => {
      const candidate = words(flavor(product, variant));
      return (!ignored.includes(candidate[0]) && viewed.includes(candidate[0])) ||
        (!ignored.includes(viewed[0]) && candidate.includes(viewed[0]));
    }) || available.find((variant) => words(flavor(product, variant)).includes(mode === 'papers' ? 'natural' : 'variety')) || available[0];
  }

  function money(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function track(event, mode) {
    const data = { event: event, kp_pair: mode };
    try { if (window.dataLayer && typeof window.dataLayer.push === 'function') window.dataLayer.push(data); }
    catch (error) { /* Analytics must not interrupt shopping. */ }
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish(event, { kp_pair: mode });
      }
    } catch (error) { /* Analytics must not interrupt shopping. */ }
  }

  function init(root) {
    if (root.hasAttribute('data-kp-pair-ready')) return;
    const data = JSON.parse(root.querySelector('[data-kp-pair-data]').textContent);
    const formSelector = 'form[id^="product-form-template"][id$="__main"]';
    const form = () => document.querySelector(formSelector);
    const heroById = (id) => data.hero.variants.find((variant) => String(variant.id) === String(id));
    const slots = [root.querySelector('[data-kp-pair-slot="1"]'), root.querySelector('[data-kp-pair-slot="2"]')];
    const options = [...root.querySelectorAll('[data-kp-pair-option]')];
    const add = root.querySelector('[data-kp-pair-add]');
    const change = root.querySelector('[data-kp-pair-change]');
    const status = root.querySelector('[role="status"]');
    const alert = root.querySelector('[role="alert"]');
    const saving = root.querySelector('[data-kp-pair-saving]');
    const chosen = new Map();
    let lastChosenFlavor = null;
    let hero = heroById(slots[0].getAttribute('data-variant-id'));
    let partner = data.partners[0];
    let selected;
    let busy = false;
    root.setAttribute('data-kp-pair-ready', '');

    function quantity() {
      const main = form();
      const input = main && [...document.querySelectorAll('input[name="quantity"]')].find((node) => node.form === main);
      const value = Number(input && input.value);
      return Number.isInteger(value) && value > 0 ? value : 1;
    }

    function selection(entry) {
      return entry.product.variants.find((variant) => variant.available && String(variant.id) === String(chosen.get(entry.product.handle))) ||
        match(entry.product, flavor(data.hero, hero), data.mode);
    }

    function slot(node, product, variant) {
      const name = flavor(product, variant);
      node.setAttribute('data-variant-id', String(variant.id));
      const label = node.querySelector('[data-kp-pair-flavor]');
      label.textContent = name;
      label.title = name;
      const img = node.querySelector('img');
      const source = variant.featured_image || product.featured_image;
      img.alt = name;
      if (source) {
        const url = new URL(typeof source === 'string' ? source : source.src, location.href);
        url.searchParams.set('width', '112');
        if (img.src !== url.href) img.src = url.href;
      } else img.removeAttribute('src');
    }

    function render() {
      // Keep these amounts aligned with automatic discount 1696514113832.
      const qualifies = data.mode === 'papers' ? hero.price * quantity() >= 250 : selected.price >= 250;
      const discount = qualifies ? 100 : 0;
      saving.hidden = !qualifies;
      saving.textContent = qualifies ? 'SAVE $1' : '';
      slot(slots[0], data.hero, hero);
      slot(slots[1], partner.product, selected);
      options.forEach((option) => {
        const entry = data.partners.find((item) => item.product.handle === option.getAttribute('data-kp-pair-option'));
        const checked = entry === partner;
        option.setAttribute('aria-checked', String(checked));
        option.tabIndex = checked ? 0 : -1;
        option.querySelector('[data-kp-pair-price]').textContent = '+' + money((checked ? selected : selection(entry)).price - (data.mode === 'papers' ? discount : 0));
      });
      add.disabled = busy || !hero.available;
      add.setAttribute('aria-busy', String(busy));
      const total = hero.price * quantity() + selected.price;
      add.textContent = hero.available ? 'ADD PAIR TO CART · ' : 'SOLD OUT';
      if (hero.available) {
        if (discount) {
          const original = document.createElement('s');
          original.textContent = money(total);
          add.append(original, ' ');
        }
        add.append(money(total - discount));
      }
    }

    function sync() {
      const main = form();
      const input = main && main.querySelector('input[name="id"]');
      const current = input && heroById(input.value);
      if (current && current !== hero) {
        hero = current;
        selected = selection(partner);
      }
      render();
    }

    selected = selection(partner);
    sync();

    options.forEach((option, index) => {
      option.addEventListener('click', () => {
        sync();
        partner = data.partners.find((item) => item.product.handle === option.getAttribute('data-kp-pair-option'));
        if (!chosen.has(partner.product.handle) && lastChosenFlavor) {
          const same = partner.product.variants.find((variant) => variant.available &&
            flavor(partner.product, variant).toLowerCase() === lastChosenFlavor);
          if (same) chosen.set(partner.product.handle, same.id);
        }
        selected = selection(partner);
        render();
      });
      option.addEventListener('keydown', (event) => {
        let next;
        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = (index + 1) % options.length;
        else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = (index + options.length - 1) % options.length;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = options.length - 1;
        else return;
        event.preventDefault();
        options[next].focus();
        options[next].click();
      });
    });

    change.addEventListener('click', async () => {
      alert.textContent = '';
      if (!window.kpPick || typeof window.kpPick.choose !== 'function') {
        alert.textContent = "Couldn't open flavors. Try again.";
        return;
      }
      const entry = partner;
      try {
        const id = await window.kpPick.choose(entry.product, {
          selectedId: selected.id, title: entry.label, subtitle: 'Choose a flavor'
        });
        const variant = entry.product.variants.find((item) => item.available && String(item.id) === String(id));
        if (!variant) return;
        chosen.set(entry.product.handle, variant.id);
        lastChosenFlavor = flavor(entry.product, variant).toLowerCase();
        if (entry === partner) selected = variant;
        render();
        status.textContent = flavor(entry.product, variant) + ' selected.';
      } catch (error) { alert.textContent = "Couldn't open flavors. Try again."; }
    });

    document.addEventListener('change', (event) => {
      const target = event.target;
      if (!(target instanceof Element)) return;
      const main = form();
      if (target.closest('variant-selects') ||
          (target.matches('input[name="id"], input[name="quantity"]') && target.form === main)) {
        setTimeout(sync, 0);
      }
    });
    document.addEventListener('input', (event) => {
      if (event.target instanceof HTMLInputElement && event.target.name === 'quantity' && event.target.form === form()) sync();
    });

    add.addEventListener('click', async () => {
      if (busy) return;
      sync();
      if (!hero.available) return;
      busy = true;
      alert.textContent = '';
      status.textContent = 'Adding your pair…';
      render();
      let json;
      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: [{ id: hero.id, quantity: quantity() }, { id: selected.id, quantity: 1, properties: { _kp_pair: 'pdp' } }],
            sections: ['cart-drawer', 'cart-icon-bubble'], sections_url: location.pathname
          })
        });
        const text = await response.text();
        json = JSON.parse(text);
        if (!response.ok || json.status) throw new Error(json.description || "Couldn't add the pair. Try again.");
      } catch (error) {
        alert.textContent = json && json.description || "Couldn't add the pair. Try again.";
        status.textContent = '';
        busy = false;
        render();
        return;
      }
      status.textContent = 'Pair added to cart.';
      try {
        const drawer = document.querySelector('cart-drawer');
        if (drawer) drawer.renderContents(json);
      } catch (error) { alert.textContent = 'Your pair was added. Open your cart to view it.'; }
      try {
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'kp-pair-window', cartData: json });
        }
      } catch (error) { /* The pair is already in the cart. */ }
      track('kp_pair_add', data.mode);
      busy = false;
      render();
    });

    if (typeof IntersectionObserver === 'function') {
      const observer = new IntersectionObserver((entries) => {
        if (entries.some((entry) => entry.isIntersecting && entry.intersectionRatio >= 0.5)) {
          observer.disconnect();
          track('kp_pair_view', data.mode);
        }
      }, { threshold: 0.5 });
      observer.observe(root);
    }
  }

  document.querySelectorAll('[data-kp-pair-window]').forEach(init);
})();